import { useTheme } from "@emotion/react";
import useTamanhoTela from "../../../../utils/useTamanhoTela";
import { Container } from "../../../produtos/promocoes/styles";
import { IconeBotao } from "../../../selecaoEmpresas/styles";
import { ItemPreenchido, TextoCabecalhoMudarPagina } from "../styles";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CabecalhoMudarPagina,
  ContainerFundoBranco,
  TextoMeusCartoes,
} from "./styles";
import ListagemCartao from "../../cartoes/listagemCartao";
import { useTranslation } from "react-i18next";

export function FormaPagamento() {
  const { t } = useTranslation("common");
  const { t: tPagamento } = useTranslation("pagamento");
  const { largura } = useTamanhoTela();
  const theme = useTheme();

  return (
    <>
      <TextoMeusCartoes>{tPagamento("paymentMethod.myCards")}</TextoMeusCartoes>
      <ListagemCartao />
    </>
  );
}
